require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-united-states-financial-regulatory-system.json") })
        }
      }, "path---posts-united-states-financial-regulatory-system");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-united-states-financial-regulatory-system!./.cache/json/posts-united-states-financial-regulatory-system.json
// module id = 411
// module chunks = 231608221292675